var map = {
	"./arrow.svg": "01c2",
	"./cart.svg": "7a6e",
	"./catalog.svg": "02dd",
	"./check.svg": "47d4",
	"./close.svg": "3a98",
	"./filter.svg": "ddf5",
	"./loader.svg": "7dc1",
	"./logo.svg": "d0e9",
	"./logoTest.svg": "a364",
	"./menu.svg": "38e0",
	"./minus.svg": "2c60",
	"./noSound.svg": "639c",
	"./plus.svg": "3962",
	"./retry.svg": "a99a",
	"./scanner.svg": "a346",
	"./search.svg": "b06f",
	"./sendOrders.svg": "7cac",
	"./sort.svg": "b9a5",
	"./sound.svg": "0a92",
	"./stickArrow.svg": "412e",
	"./trash.svg": "a321",
	"./user.svg": "63a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d69b";